import { loadZendeskWidgetChat } from '@/libs/zendesk';
import { Env } from '@/env';

class ZendeskService {
  /**
   * @var boolean
   */
  isLoaded;

  constructor() {
    this.isLoaded = false;
  }

  init() {
    if (!this.isLoaded && !Env.isUnitTesting()) {
      loadZendeskWidgetChat();
      this.isLoaded = true;
    }
  }

  isWebWidgetLoaded() {
    return this.isLoaded;
  }

  hideZendeskWebWidget() {
    if (window.zE && this.isLoaded && !Env.isUnitTesting()) {
      // eslint-disable-next-line tap/no-raw-text-js
      window.zE('messenger', 'hide');
    }
  }

  showZendeskWebWidget() {
    if (window.zE && this.isLoaded && !Env.isUnitTesting()) {
      // eslint-disable-next-line tap/no-raw-text-js
      window.zE('messenger', 'show');
    }
  }
}

export default new ZendeskService();
